module.exports = global["jQuery"] = require("-!C:\\vstsagent\\_work\\163\\s\\node_modules\\expose-loader\\index.js?$!.\\jquery.slim.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.slim.js-exposed
// module id = 29
// module chunks = 0 1 3 6 8